<template>
    <div>
        <v-container>
            <v-row class="mb-2">
                <v-col offset="8" class="text-right">
                    <v-btn @click="addStatistic">Add Statistic</v-btn>
                </v-col>
            </v-row>

            <v-row v-for="(statisticWindow, index) in statisticWindows" :key="index">
                <v-col>
                    <meet-statistic-window :meet="meet" />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Meet from '@/Models/Meet.js';
import MeetStatisticWindow from '@/Components/MeetStatistics/MeetStatisticWindow.vue';

export default {
    name: 'MeetStatistics',

    components: {
        MeetStatisticWindow,
    },

    props: {
        meet: {
            type: Meet,
            required: true,
        },
    },

    data: () => ({
        loading: false,
        statisticWindows: [],
    }),

    methods: {
        addStatistic() {
            this.statisticWindows.push(this.statisticWindows.length + 1);
        },
    },
};
</script>
